import React from "react";
import { Card, Typography, Button, Space, Tag, message } from "antd";
import {
  BookOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  ReadOutlined,
  SendOutlined 
} from "@ant-design/icons";
import "../styles/HorizontalCourseCard.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import CartApiService from "../services/CartApiService";
import { Role } from "../constants/Role";
import LazyImage from "./ui/LazyImage";
const { Title, Text } = Typography;

const HorizontalCourseCard = ({
  id,
  rawId,
  courseSlug,
  image,
  title,
  author,
  totalSections,
  lessonCount,
  price,
  category,
  isPurchased = false,
  isInCart = false,
  refetchCart,
}) => {
  const navigate = useNavigate();
  const { authenticated, login, hasAnyRole } = useAuth();
  
  const handleAddToCart = async (e) => {
    e.stopPropagation(); 
    console.log('Add to cart:', id, 'rawId:', rawId);
    if (!authenticated) {
      message.warning('Please login to add courses to cart!');
      login();
      return;
    }

    // Chỉ cho phép role LEARNER thêm vào cart
    if (!hasAnyRole([Role.LEARNER])) {
      message.warning('Only learners can add courses to cart!');
      return;
    }

    // Kiểm tra xem có id không
    if (!id) {
      message.error('Unable to add course to cart! (id does not exist)');
      console.error('Unable to add course to cart! id:', id, 'rawId:', rawId);
      return;
    }

    try {
      const res = await CartApiService.addToCart(id);
      if (res.success) {
        message.success('Course added to cart successfully!');
        if (refetchCart) await refetchCart();
        
        window.dispatchEvent(new Event('cart-changed'));
      } else {
        message.error('Add to cart failed!');
      }
    } catch (err) {
      if (err.response?.status === 401) {
        message.error('Your session has expired. Please log in again!');
        login();
      } else {
        message.error('Add to cart failed!');
      }
    }
  };

  const handleGoToCart = (e) => {
    e.stopPropagation();
    navigate('/cart');
  };

  const handleLearnCourse = (e) => {
    e.stopPropagation();
    if (courseSlug) {
      navigate(`/learner/my-courses/${courseSlug}`);
    }
  };

  const handleCardClick = () => {
    if (courseSlug) {
      if (isPurchased) {
        navigate(`/learner/my-courses/${courseSlug}`);
      } else {
        navigate(`/courses/${courseSlug}`);
      }
    }
  };

  return (
    <Card
      className="horizontal-card"
      bodyStyle={{ padding: 0 }}
      onClick={handleCardClick}
    >
      <div className="horizontal-card-content">
        <div className="horizontal-card-image-container">
          <LazyImage 
            src={image} 
            alt={title} 
            className="horizontal-card-image"
            height={150}
            offset={100}
          />
        </div>

        <div className="horizontal-card-info" style={{ position: 'relative' }}>
          <Text className="horizontal-card-author">by {author || "N/A"}</Text>
          {category && (
            <div style={{ position: 'absolute', top: 0, right: 0 }}>
              <Tag
                color="geekblue"
                style={{
                  display: "inline-block",
                  fontWeight: 500,
                  fontSize: 13,
                  borderRadius: 8,
                  marginTop: 10,
                  padding: "2px 12px",
                  marginRight: 18,
                }}
              >
                {category}
              </Tag>
            </div>
          )}
          <Title level={4} className="horizontal-card-title">
            {title}
          </Title>

          <Space size="large" className="horizontal-card-meta">
            <span>
              <BookOutlined style={{ color: "#1677ff" }} /> {totalSections}{" "}
              Sections
            </span>
            <span>
              <FileTextOutlined style={{ color: "#1677ff" }} /> {lessonCount}{" "}
              Lessons
            </span>
          </Space>

          <div className="horizontal-card-footer">
            <Text className="horizontal-card-price">${price}</Text>
            {isPurchased ? (
              <ReadOutlined
                className="course-learn-icon"
                title="Learn Course"
                onClick={handleLearnCourse}
              />
            ) : isInCart ? (
              <SendOutlined
                className="course-go-to-cart"
                title="View cart"
                onClick={handleGoToCart}
              />
            ) : (
              <ShoppingCartOutlined
                className="course-add-to-cart"
                title="Add to cart"
                onClick={handleAddToCart}
              />
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default HorizontalCourseCard;
